import React from "react";
import styled from "styled-components";
import { layout, LayoutProps, space, SpaceProps } from "styled-system";

const TableContainer: React.FC<LayoutProps & SpaceProps> = styled.table`
  ${space};
  ${layout};
  border-collapse: collapse;
  table-layout: fixed;
`;

export const Table: React.FC<LayoutProps & SpaceProps> = ({ children, ...props }) => (
  <TableContainer {...props}>
    <tbody>{children}</tbody>
  </TableContainer>
);
